export var isAbsoluteUrl = function (url) { return /^(?:[a-z]+:)?\/\//i.test(url); };
